import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var toVoiceFetchers = function toVoiceFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    Search: toFetcher(function (params) {
      return "Search".concat(params.q);
    }, function (params) {
      return unwrap(function () {
        return api.axios.get('/search', {
          headers: {
            'X-Aiqudo-PartnerId': 'd70e6fb4a6bf435e90379f19859028ac',
            'X-Aiqudo-PartnerSecret': 'c197b678172f4cbeacae6339fc1b8b36',
            'X-Aiqudo-Locale': 'en_US',
            'X-Aiqudo-ClientFeatureSupport': 'all',
            platform: 'android',
            actionKitVersion: '3'
          },
          params: params
        });
      });
    })
  };
};